<template>
  <div id="app">
    <NavigationBar class="mb-5" />
    <b-container>
      <router-view></router-view>
    </b-container>
  </div>
</template>

<script>
import NavigationBar from './components/NavigationBar'

export default {
  name: 'APP',
  components: {
    NavigationBar
  },
  filters: {},
  mixins: {},
  props: {},
  data: function () {
    return {}
  },
  computed: {},
  watch: {},
  created () {},
  methods: {}
}
</script>
